import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { Suspense, useEffect } from "react";
import { ProjectShell } from "@/features/shell/ProjectShell";
import { ApiError } from "@/lib/api/client";
import { projectQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";
import { useUiStore } from "@/lib/stores/ui";
import { PagePending } from "@/routes/__root";

/** Project layout: sidebar, top bar, environment scope. Children render inside the shell. */
export const Route = createFileRoute("/w/$workspace/p/$project")({
  validateSearch: projectSearch,
  loader: async ({ context, params }) => {
    try {
      return await context.queryClient.ensureQueryData(
        projectQuery(params.workspace, params.project),
      );
    } catch (e) {
      if (e instanceof ApiError && e.status === 404) throw notFound();
      throw e;
    }
  },
  component: ProjectLayout,
});

function ProjectLayout() {
  const { workspace, project } = Route.useParams();
  const { env = DEFAULT_ENV } = Route.useSearch();
  const rememberProject = useUiStore((s) => s.rememberProject);
  useEffect(() => rememberProject(workspace, project), [workspace, project, rememberProject]);
  return (
    <ProjectShell workspace={workspace} project={project} env={env}>
      <Suspense fallback={<PagePending />}>
        <Outlet />
      </Suspense>
    </ProjectShell>
  );
}
